import styled, { css } from 'styled-components'

const FooterBtnText = ({ totalSceneNum, currSceneNum }) => {
  const isLastScene = totalSceneNum === currSceneNum
  const btnTxt = isLastScene ? '완료' : '다음'

  return (
    <TextBlock>
      <BtnTxt>{btnTxt}</BtnTxt>
      {!isLastScene ? <SceneNum>{`${currSceneNum}/${totalSceneNum}`}</SceneNum> : null}
    </TextBlock>
  )
}

const TextBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: inherit;
`

const textStyle = css`
  color: inherit;
`

const BtnTxt = styled.span`
  ${textStyle}
  font-size: calc(100vw * (18 / 375));
  font-weight: inherit;
  line-height: calc(100vw * (26 / 375));
  margin-right: calc(100vw * (8 / 375));
`

const SceneNum = styled.span`
  ${textStyle}
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (20 / 375));
`

export default FooterBtnText
